import { generateSkinDefaults } from '@wix/editor-elements-panel';
import { stylableButtonSkinDefinitionMap } from '../../StylableButton/StylableButton.skinParams';

export const hamburgerOpenButtonSkin = 'wixui.skins.hamburgerOpenButton';

export const hamburgerOpenButtonSkinDefinition = {
  [hamburgerOpenButtonSkin]:
    stylableButtonSkinDefinitionMap['wixui.skins.StylableButton'],
};

export default generateSkinDefaults(hamburgerOpenButtonSkinDefinition);
